/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockSharedRecipes
 * @description Data access service for managing shared recipes
 */
angular.module('mercury.modules.stock.recipe')
.factory('StockSharedRecipes', ["$http", "$q", "$resource", "settings", function($http, $q, $resource, settings) {
  var SharedRecipes = $resource(settings.apiHost + '/r/StockSharedRecipes', {}, {save: {isArray: true, method: 'POST'}});
  var StockSharing = $resource(settings.apiHost + '/r/StockSharing', {});

  /**
   * Get the shared details of a specific company recipe
   *
   * @memberof StockSharedRecipes
   * @param  {String} recipeId The local recipe id
   */
  function get(recipeId) {
    return SharedRecipes.query({recipeId: recipeId});
  }

  /**
   * Get the share plan for sharing specifid recipes to a specific company
   *
   * @memberof StockSharedRecipes
   * @param  {Object} localRecipeIds  Array of recipe ids
   * @param  {String} targetCompanyId Id of the company to share to
   */
  function getSharePlan(localRecipeIds, targetCompanyId) {
    return SharedRecipes.save({targetCompanyId: targetCompanyId}, localRecipeIds).$promise;
  }

  /**
   * Execute a share plan
   *
   * @memberof StockSharedRecipes
   * @param  {Object} plan            Share plan model
   * @param  {String} targetCompanyId Id of the company to share to
   */
  function executeSharePlan(plan, targetCompanyId) {
    return StockSharing.save({targetCompanyId: targetCompanyId}, plan).$promise;
  }

  /**
   * Delete a specific shared recipe
   *
   * @memberof StockSharedRecipes
   * @param  {Object} sharedRecipe shared recipe model
   */
  function deleteCompanyRecipe(sharedRecipe) {
    var deferred = $q.defer();

    var config = {
      headers: {
        'x-loaded-company-id': sharedRecipe.sharedCompanyId
      }
    };

    var data = [{op: 'replace', path: 'DatestampDeleted', value: moment().format()}];

    $http.patch(settings.apiHost + '/r/StockRecipes/' + sharedRecipe.sharedCompanyRecipeId, data, config)
    .then(function(result) {
      deferred.resolve(result.data);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  /**
   * Search the recipes of a specific company
   *
   * @memberof StockSharedRecipes
   * @param  {String} companyId Id of the company
   * @param  {String} searchStr search phrase query
   */
  function searchCompanyRecipes(companyId, searchStr) {
    var deferred = $q.defer();

    var config = {
      headers: {
        'x-loaded-company-id': companyId
      },
      params: {
        $filter: 'contains(Name, \'' + searchStr.replace(/\'/g, '\'\'') + '\') and IsShared eq false'
      }
    };

    $http.get(settings.apiHost + '/r/StockRecipes', config)
    .then(function(result) {
      deferred.resolve(result.data);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  return {
    get: get,
    getSharePlan: getSharePlan,
    executeSharePlan: executeSharePlan,
    deleteCompanyRecipe: deleteCompanyRecipe,
    searchCompanyRecipes: searchCompanyRecipes
  };
}]);
